module.exports = __webpack_public_path__ + "media/images/vp/assistance.newtask-edfb3c17d3ff8dbedd12220ac706d310.svg";